import { useContext } from "react";
import EventContext from "../contexts/EventContext";

/**
 * Hook to access event context
 * Returns event data, loading state, and error
 * @returns {Object} { event, loading, error }
 */
const useEvent = () => {
  const context = useContext(EventContext);

  // If context is undefined or doesn't have expected structure, return safe defaults
  if (!context || typeof context !== "object") {
    console.warn("[useEvent] Context is invalid, returning defaults", context);
    return {
      event: null,
      loading: false,
      error: null,
    };
  }

  return context;
};

export default useEvent;
